import Vue from 'vue'
import axios from 'axios'
import { SimpleLookupItem } from '@/models/SimpleLookupItem'
import { LookupService } from '@/services/LookupService'
import { Category } from '@/models/Category'

interface SearchResultItem {
  parentUrl: string;
  parentName: string;
  imageUrl: string;
  url: string;
  name: string;
  description: string;
  type: string;
  isNew: boolean;
  productListingType: string;
}

interface SearchResults {
  firstDisplayPage: number;
  lastDisplayPage: number;
  pageSize: number;
  maxPageListSize: number;
  allItems: SearchResultItem[];
  searchTitle: string;
  resultViewTitle: string;
  totalItems: number;
  page: number;
  totalPages: number;
  testItems: string[];
}

if (document.querySelector("#app-search") !== null) {
  new Vue({
    el: '#app-search',
    data: {
      parameters: {
        type: '',
        keywords: '',
        category: 0,
        company: 0,
        page: 1,
        b2b: false,
        industry: 0,
        state: ''
      },
      companyName: '',
      paging: {
        totalPages: 0,
        maxListSize: 10,
        firstDisplayPage: 1,
        lastDisplayPage: 1,
        pageSize: 10,
      },
      results: {
        list: [] as SearchResultItem[],
        count: 0,
        searchTitle: '',
        resultViewTitle: 'View',
        industryTypes: [] as SimpleLookupItem[],
        parentCategories: [] as Category[],
        subCategories: [] as Category[],
        states: [] as SimpleLookupItem[],
        selectedType: '',
        keywordCSS: 'd-none',
        typeCSS: 'd-none',
        categoryCSS: 'd-none',
        subCategoryCSS: 'd-none',
        stateCSS: 'd-none',
        industryCSS: 'd-none',
        selectedParentId: 0
      },
      loaded: false,
      selectedCat1: 0,
      selectedCat2: 0,
      selectedType: '',
      searched: false
    },
    computed: {
      pagerSize(): number {
        return this.paging.lastDisplayPage - this.paging.firstDisplayPage + 1
      }
    },
    methods: {
      animateCounter(): void {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const counterUp = window.counterUp["default" as any]
        counterUp(this.$refs.counter, { delay: 10, time: 1000 })
      },

      async performSearchAsync(): Promise<SearchResults | null> {
        try {
          const apiUrl = '/Umbraco/Api/SearchApi/PerformSearch'
          // const response2 = await axios.get(`${process.env.VUE_APP_BASE_URL}${apiUrl}2?type=${this.parameters.type}&Keywords=${this.parameters.keywords}&category=${this.parameters.category}
          //   &company=${this.parameters.company}&page=${this.parameters.page}&B2B=${this.parameters.b2b}&industry=${this.parameters.industry}&state=${this.parameters.state}`)
          //   alert(response2.data)
          const response = await axios.get(`${process.env.VUE_APP_BASE_URL}${apiUrl}?type=${this.parameters.type}&Keywords=${this.parameters.keywords}&category=${this.parameters.category}
            &company=${this.parameters.company}&page=${this.parameters.page}&B2B=${this.parameters.b2b}&industry=${this.parameters.industry}&state=${this.parameters.state}`)



          let data: SearchResults = response.data
          if (typeof data !== 'object') {
            alert('data not an object')
            data = {} as SearchResults
          }
          return data
        }
        catch (error) {
          alert(error)
          return null
        }

      },

      performFilter(): void {
        this.searched = false
        this.internalPerformSearch()
      },

      performSearch(): void {
        // Clear category from subsequent searches as we have no way of doing it otherwise
        // And don't want to let it interfere with subsequent search queries.
        this.parameters.category = 0
        this.internalPerformSearch()
      },

      internalPerformSearch(): void {
        this.performSearchAsync()
          .then((data) => {
            if (data) {
              this.parameters.page = data.page
              this.paging.totalPages = data.totalPages
              this.paging.firstDisplayPage = data.firstDisplayPage
              this.paging.lastDisplayPage = data.lastDisplayPage
              this.paging.pageSize = data.pageSize
              this.paging.maxListSize = data.maxPageListSize
              this.results.list = data.allItems
              this.results.searchTitle = data.searchTitle
              this.results.resultViewTitle = data.resultViewTitle

              this.results.count = data.totalItems

              // setup the counter animation.
              window.setTimeout(() => { this.animateCounter() }, 10)
            }
          })
          .catch((error) => {
            alert(error.config)
            console.log(error)
          })
          .then(() => {
            this.searched = true
            this.calculatePages()
          })
      },
      nextPage(): void {
        this.parameters.page++
        this.internalPerformSearch()
      },
      previousPage(): void {
        this.parameters.page--
        this.internalPerformSearch()
      },
      gotoPage(page: number): void {
        this.parameters.page = page
        this.internalPerformSearch()
      },
      calculatePages(): void {
        const halfwayPoint = this.paging.maxListSize / 2
        if (this.paging.maxListSize > 0 && this.paging.maxListSize < this.paging.totalPages) {
          this.paging.firstDisplayPage = this.parameters.page - (halfwayPoint)
          this.paging.lastDisplayPage = this.parameters.page + (halfwayPoint)

          if (this.paging.firstDisplayPage < 1) {
            this.paging.firstDisplayPage = 1
            this.paging.lastDisplayPage = this.paging.maxListSize
          }

          if (this.paging.lastDisplayPage > this.paging.totalPages) {
            this.paging.lastDisplayPage = this.paging.totalPages
          }

          if (this.paging.lastDisplayPage - this.paging.firstDisplayPage < this.paging.maxListSize) {
            if (this.paging.firstDisplayPage <= halfwayPoint) {
              this.paging.firstDisplayPage = 1
              this.paging.lastDisplayPage = this.paging.maxListSize + 1
            } else {
              this.paging.lastDisplayPage = this.paging.totalPages
              this.paging.firstDisplayPage = this.paging.totalPages - this.paging.maxListSize
            }
          }
        } else {
          this.paging.firstDisplayPage = 1
          this.paging.lastDisplayPage = this.paging.totalPages
        }
        this.loaded = true
      },
      getSubCategory(parentLevelId: number): void {
        this.parameters.category = parentLevelId
        this.getCategories(parentLevelId)
      },
      checkSelectedSubCategory(selectedSubCat: number): void {
        if (selectedSubCat == 0) {
          this.parameters.category = this.results.selectedParentId
        }
      },
      getCategories(parentLevelId: number): void {
        const lookupService = new LookupService()

        lookupService
          .GetCategories(parentLevelId)
          .then(response => {
            if (parentLevelId == 0) {
              this.results.parentCategories = response
              this.results.subCategories = []
            }
            else {
              this.results.subCategories = response
            }
            return;
          })
          .catch(error => {
            console.log(error);
          });
      },
      onSelectedType(): void {
        switch (this.parameters.type) {
          case "Products":
            this.results.keywordCSS = 'col-md-2'
            this.results.typeCSS = 'col-md-2'
            this.results.categoryCSS = 'col-md-3'
            this.results.subCategoryCSS = 'col-md-3'
            this.results.industryCSS = 'd-none'
            this.results.stateCSS = 'd-none'
            this.parameters.state = ''
            this.parameters.industry = 0
            break;
          case "Companies":
            this.results.keywordCSS = 'col-md-3'
            this.results.typeCSS = 'col-md-2'
            this.results.categoryCSS = 'd-none'
            this.results.subCategoryCSS = 'd-none'
            this.results.industryCSS = 'col-md-3'
            this.results.stateCSS = 'col-md-2'
            this.parameters.state = ''
            this.parameters.category = 0
            break;
          case "Site":
            this.results.keywordCSS = 'col-md-5'
            this.results.typeCSS = 'col-md-5'
            this.results.categoryCSS = 'd-none'
            this.results.subCategoryCSS = 'd-none'
            this.results.industryCSS = 'd-none'
            this.results.stateCSS = 'd-none'
            this.parameters.state = ''
            this.parameters.industry = 0
            this.parameters.category = 0
            break;
        }
      }
    },
    watch: {
      selectedCat1: function () {
        this.results.selectedParentId = this.selectedCat1;
        this.getSubCategory(this.results.selectedParentId);
      },
      selectedCat2: function () {
        this.parameters.category = this.selectedCat2;
        this.checkSelectedSubCategory(this.selectedCat2);
      },
      selectedType: function () {
        this.parameters.type = this.selectedType;
        this.onSelectedType();
      }
    },
    created(): void {
      const params = new URLSearchParams(window.location.search)
      const lookupService = new LookupService()
      const b2b = params.get('b2b')
      let selectedCategory = 0 as number | null | undefined
      this.parameters.b2b = b2b !== null && b2b === "1"

      let type = params.get('type')
      this.parameters.category = +(params.get('category') ?? 0)

      if (this.parameters.category > 0) {
        type = 'Products'
        this.selectedType = 'Products'
      }

      // Sanitise the type.
      if (type?.toLowerCase() === 'products') {
        this.parameters.type = 'Products'
        this.selectedType = 'Products'
      } else if (type?.toLowerCase() === 'companies') {
        this.parameters.type = 'Companies'
        this.selectedType = 'Companies'
      } else {
        this.parameters.type = 'Site'
        this.selectedType = 'Site'
      }

      this.parameters.keywords = params.get('value') ?? ''

      this.parameters.company = +(params.get('company') ?? 0)

      this.internalPerformSearch()



      lookupService
        .GetIndustryType()
        .then((response) => {
          if (response !== null) {
            this.results.industryTypes = response;
            return;
          }
        })
        .catch((error) => {
          console.log(`Error retrieving Major Retailer list: ${error}`);
        });

      lookupService
        .GetAustralianStates(true)
        .then((response) => {
          if (response !== null) {
            this.results.states = response;
            return;
          }
        })
        .catch((error) => {
          console.log(`Error retrieving states list: ${error}`);
        });

      this.getCategories(0);

      if (this.parameters.category > 0) {
        lookupService
          .GetCategoryLevelIds(this.parameters.category)
          .then((response) => {
            if (response !== null) {
              selectedCategory = response.ParentCategory1;

              if (selectedCategory !== undefined && selectedCategory !== null && selectedCategory > 0) {
                this.selectedCat1 = selectedCategory;
                this.getCategories(selectedCategory)
              }
              else {
                this.selectedCat1 = this.parameters.category
                this.getCategories(this.parameters.category)
              }

              if (response.ParentCategory2 > 0) {
                this.selectedCat2 = response.ParentCategory2;
              }
              return;
            }
          })
          .catch((error) => {
            console.log(`Error retrieving states list: ${error}`);
          });
      }

      this.onSelectedType();
    }
  })
}
